'use client';

import { usePathname, useSearchParams } from 'next/navigation';

const useGetAsPath = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return `${pathname}${
    searchParams?.toString() ? `?${searchParams.toString()}` : ''
  }`;
};

export default useGetAsPath;
